import React, { SVGProps } from 'react'

export const IconFilter2Count = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="-4 0 24 22" width="24" height="24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M 7.671 3.602 L 1.246 3.602 C 0.901 3.602 0.571 3.75 0.336 4.01 C 0.1 4.271 -0.02 4.62 0.003 4.976 L 0.031 5.292 C 0.377 8.545 2.539 11.262 5.511 12.264 L 5.785 12.35 L 5.786 18.314 C 5.786 18.814 6.066 19.269 6.503 19.481 C 6.941 19.692 7.458 19.623 7.829 19.304 L 9.764 17.638 L 9.878 17.526 C 10.091 17.29 10.212 16.976 10.212 16.648 L 10.211 12.35 L 10.487 12.265 C 10.875 12.134 10.769 12.168 10.979 12.086 C 10.249 11.79 9.734 11.501 9.297 10.962 L 9.183 10.996 C 8.889 11.109 8.687 11.401 8.687 11.734 L 8.687 16.513 L 7.31 17.699 L 7.311 11.734 C 7.311 11.359 7.056 11.037 6.701 10.962 L 6.427 10.898 C 3.895 10.245 1.994 8.087 1.588 5.441 L 1.552 5.177 L 7.242 5.177 C 7.314 4.645 7.434 4.124 7.671 3.602 Z"
        fill="currentColor"
      />
      <circle cx="14" cy="6" r="6" fill="currentColor" />
    </svg>
  )
}
